import ScrollMagic from 'scrollmagic'

export default {
  init() {
    ////////////////////////////////////////////////////////////////////////////////////////////
    // Scroll Magic
    ////////////////////////////////////////////////////////////////////////////////////////////
    var controller = new ScrollMagic.Controller();

    // Toggle burger menu colour
    new ScrollMagic.Scene({triggerElement: '#about', duration: $('#about').outerHeight(), triggerHook: 'onLeave', offset: '-70'})
      .setClassToggle('#toggle-nav', 'dark') // add class toggle
      .addTo(controller);
    new ScrollMagic.Scene({triggerElement: '#news-header', duration: $('#news-header').outerHeight(), triggerHook: 'onLeave', offset: '-70'})
      .setClassToggle('#toggle-nav', 'dark') // add class toggle
      .addTo(controller);

    //Toggle nav pips
    new ScrollMagic.Scene({triggerElement: '#home', duration: $('#home').outerHeight(), triggerHook: 'onLeave'})
      .setClassToggle('#pip1', 'active') // add class toggle
      .addTo(controller);
    new ScrollMagic.Scene({triggerElement: '#about', duration: $('#about').outerHeight(), triggerHook: 'onLeave'})
      .setClassToggle('#pip2', 'active') // add class toggle
      .addTo(controller);
    new ScrollMagic.Scene({triggerElement: '#what-we-do', duration: $('#what-we-do').outerHeight(), triggerHook: 'onLeave'})
      .setClassToggle('#pip3', 'active') // add class toggle
      .addTo(controller);
    new ScrollMagic.Scene({triggerElement: '#portfolio', duration: $('#portfolio').outerHeight(), triggerHook: 'onLeave'})
      .setClassToggle('#pip4', 'active') // add class toggle
      .addTo(controller);
    new ScrollMagic.Scene({triggerElement: '#testimonials', duration: $('#testimonials').outerHeight(), triggerHook: 'onLeave'})
      .setClassToggle('#pip5', 'active') // add class toggle
      .addTo(controller);
    new ScrollMagic.Scene({triggerElement: '#news', duration: $('#news').outerHeight(), triggerHook: 'onLeave'})
      .setClassToggle('#pip6', 'active') // add class toggle
      .addTo(controller);
    new ScrollMagic.Scene({triggerElement: '#contact', duration: $('#contact').outerHeight(), triggerHook: 'onLeave'})
      .setClassToggle('#pip7', 'active') // add class toggle
      .addTo(controller);
    },
  finalize() {

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js